<template>
  <div class="container__comments">
    <div class="d-flex">
      <b-col v-if="forumThreads.length > 0" class="threads-sorter py-3 px-0">
        <b-dropdown text="Sort" variant="outline-primary" class="input__sort">
          <b-dropdown-item
            v-for="sort in sortOptions"
            :ref="`sort__${sort.value}`"
            :key="sort.value"
            :disabled="sort.disabled"
            :active="sort.value == filter.sort"
            @click="onSortChange(sort)"
          >
            {{ sort.name }}</b-dropdown-item
          >
        </b-dropdown>
      </b-col>

      <slot name="top-right" />
    </div>

    <div class="list__comments">
      <forum-thread-group
        v-for="thread in forumThreads"
        :key="`forum_${forum.id}_thread_${thread.id}`"
        ref="threadGroup"
        :thread="thread"
        :learning-unit="learningUnit"
      ></forum-thread-group>

      <b-button
        v-if="isShowLoadMore"
        ref="btn__load-more"
        variant="link"
        class="load-more-threads text-primary py-2"
        @click.prevent="onLoadMoreClick"
        >View more comments</b-button
      >
    </div>
  </div>
</template>
<script>
import Forum from '@/models/Forum';
import ForumThreads from '@/models/ForumThreads';
import LearningUnit from '@/models/LearningUnit';
import ForumThreadGroup from './ForumThreadGroup.vue';

export default {
  components: {
    ForumThreadGroup
  },
  props: {
    forum: {
      type: Forum,
      required: true
    }
  },
  data() {
    return {
      threads: [],
      total: 0,
      filter: {
        startAt: null,
        endAt: null,
        chuckIndex: 0,
        limit: 5,
        sort: this.$route.query.sort || 'latest'
      },
      isFetching: false,
      sortOptions: [
        {
          name: 'Top comments',
          value: 'popular',
          disabled: this.forumThreads && this.forumThreads.length
        },
        {
          name: 'Oldest - Latest',
          value: 'oldest',
          disabled: false
        },
        {
          name: 'Latest - Oldest',
          value: 'latest',
          disabled: false
        }
      ]
    };
  },
  computed: {
    isShowLoadMore() {
      return this.threads.length < this.total;
    },
    forumThreads() {
      return this.threads
        .map((thread) =>
          ForumThreads.query().with('user').with('liked').where('id', thread.id).first()
        )
        .filter(Boolean);
    },
    learningUnit() {
      return LearningUnit.query()
        .whereHas('sections', (query) => {
          query.where('id', this.forum.section_id);
        })
        .first();
    }
  },
  async mounted() {
    await this.fetchThreadsMeta();

    await this.fetchThreads();
  },
  methods: {
    async fetchThreadsMeta() {
      const { response } = await ForumThreads.api().fetchForumThreadsMeta(this.forum.id);

      if (response.data?.total) {
        this.total = response.data?.total;
      }
      if (response.data?.startAt) {
        this.filter.startAt = response.data.startAt.id;
      }
      if (response.data?.endAt) {
        this.filter.endAt = response.data.endAt.id;
      }
    },

    async fetchThreads() {
      const { response } = await ForumThreads.api().fetchForumThreads(
        this.forum.id,
        this.filter.startAt,
        this.filter.endAt,
        this.filter.chuckIndex,
        this.filter.limit,
        this.filter.sort
      );

      if (response.data.length > 0) {
        this.threads.push(...response.data);
      }
    },

    async onSortChange({ value } = {}) {
      this.filter.sort = value;
      this.$router.push({
        query: {
          ...this.$route.query,
          sort: value
        }
      });

      await this.fetchThreadsMeta();

      this.filter.chuckIndex = 0;

      this.threads = [];

      await this.fetchThreads();
    },

    async onLoadMoreClick() {
      this.filter.chuckIndex += 1;

      await this.fetchThreads();
    },

    handleNewThread(newForumThread) {
      // should change to the same format as response data in fetch!
      this.threads.unshift(newForumThread);
    }
  }
};
</script>
<style scoped lang="css">
.container__forum-threads {
  display: flex;
  flex-direction: column;
}

.threads-sorter {
  display: flex;
  flex-direction: row;
}

.threads-sorter > b-dropdown:nth-child(1) {
  width: 100%;
  max-width: 12rem;
}

.threads {
  padding-bottom: 2rem;
}

.load-more-threads {
  padding: 1.25rem 1rem;
  color: #007bff;
}

.load-more-threads > a {
  color: #007bff;
  cursor: pointer;
}

.load-more-threads > a:hover {
  text-decoration: underline;
}
</style>
